import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
export const Hero = () => {
  const scrollToPortfolio = () => {
    const element = document.getElementById('portfolio');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-124">
      {/* Abstract background with animation feel */}
      <div className="absolute inset-0 z-0" data-id="element-125">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-indigo-900/40 via-purple-900/30 to-gray-900" data-id="element-126"></div>
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-indigo-600/20 rounded-full blur-3xl animate-pulse" data-id="element-127"></div>
        <div className="absolute bottom-1/3 right-1/3 w-64 h-64 bg-purple-600/20 rounded-full blur-3xl animate-pulse" style={{
        animationDelay: '1s'
      }} data-id="element-128"></div>
      </div>
      <div className="container mx-auto px-4 z-10 text-center" data-id="element-129">
        <h1 className="text-5xl md:text-7xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-purple-400" data-id="element-130">
          Sparrymation
        </h1>
        <p className="text-2xl text-indigo-400 mb-4" data-id="element-131">Søren Bro Sparre</p>
        <p className="text-xl md:text-2xl text-gray-300 max-w-2xl mx-auto mb-10" data-id="element-132">
          Bringing imagination to life through stunning 3D animation
        </p>
        <button onClick={scrollToPortfolio} className="bg-indigo-600 hover:bg-indigo-700 text-white py-3 px-8 rounded-full transition-colors flex items-center mx-auto" data-id="element-133">
          View My Work
          <ArrowDownIcon size={20} className="ml-2" data-id="element-134" />
        </button>
      </div>
    </section>;
};